<app-navbar-small></app-navbar-small>
<div class="m-lg-4"><div class="row d-flex justify-content-center">
  <h2 style="color: #0D446E"><b>Pulsar Signals Confirmed by Experts</b></h2>
</div></div>
<table mdbTable striped="true">
  <thead>
  <tr>
    <th *ngFor="let head of headElements" scope="col">{{head}} </th>
  </tr>
  </thead>
  <div *ngIf="(items | async)?.length==0">
    <p class="container -align-center">No records are available!</p></div>
  <tbody>

  <ng-container mdbTableCol *ngFor="let item of items | async">
    <tr *ngIf="item.targetClass == 1">

    <td scope="row">{{item.meanOfTheIntegratedProfile}}</td>
    <td>{{item.standardDeviationOfTheIntegratedProfile}}</td>
    <td>{{item.excessKurtosisOfTheIntegratedProfile}}</td>
    <td>{{item.skewnessOfTheIntegratedProfile}}</td>
    <td>{{item.meanOfTheDMSNRCurve}}</td>
    <td>{{item.standardDeviationOfTheDMSNRCurve}}</td>
    <td>{{item.excessKurtosisOfTheDMSNRCurve}}</td>
    <td>{{item.skewnessOfTheDMSNRCurve}}</td>
  </tr>
    </ng-container>
  </tbody>
</table>



